module.exports = __webpack_public_path__ + "img/download.8b87dadb.svg";